import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import moment from 'moment';
import $ from 'jquery';
import { useSelector, useDispatch } from 'react-redux';
import Progress from './ui/react-ui/progress.jsx';
import DateRange from './ui/react-ui/date-range';
import TopTenDriver from './logisticDeliver/topTenDriver';
import DeliverLog from './logisticDeliver/deliverLog'; // api

import { getStatsLogisticsTop10, getLogsLogisticsAll } from '../api/statsAPI'; // redux

import { setLogsLogisticsList, setLogisticTotal, setTopTenDriverList, setDateTime, setIsDateTimeChange, reset } from '../redux/logistic-deliver';
var t = i18n.getFixedT(null, 'logistic-deliver');
var gt = i18n.getFixedT(null, 'app');

var LogisticDeliver = function LogisticDeliver(props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$logistic = _useSelector.logisticDeliver,
      dateTime = _useSelector$logistic.dateTime,
      isDateTimeChange = _useSelector$logistic.isDateTimeChange,
      logisticId = _useSelector$logistic.logisticId,
      logisticKeyword = _useSelector$logistic.logisticKeyword,
      logisticSort = _useSelector$logistic.logisticSort,
      logisticRowsPerPage = _useSelector$logistic.logisticRowsPerPage,
      logisticCurrentPage = _useSelector$logistic.logisticCurrentPage;

  var dispatch = useDispatch();
  var id = props.id;
  var isMounted = useRef(false); // const isChange = useRef(true)
  // const beforeDateTime = useRef()

  var initDateTime = {
    // from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
    from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
    to: moment().format('YYYY-MM-DD HH:mm')
  };

  var handleChangeDateTime = function handleChangeDateTime(dateTime) {
    dispatch(setDateTime(dateTime));
  }; // const handleCloseDateRange = value => {
  //     if(_.isEqual(beforeDateTime.current, value))
  //         return
  //     dispatch(setIsDateTimeChange(!isChange.current))
  // }


  var fetchData = function fetchData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _currentPage, _rowsPerPage, _keyword, _logisticId, _dateTime;

    _currentPage = isInit ? 0 : logisticCurrentPage;
    _rowsPerPage = isInit ? 10 : logisticRowsPerPage;
    _keyword = isInit ? '' : logisticKeyword;
    _logisticId = isInit ? '' : logisticId;
    _dateTime = isInit ? initDateTime : dateTime;

    var offset = (Number(_currentPage + 1) - 1) * _rowsPerPage;

    Progress.startSpin(); // let getTop10Driver_api = getStatsLogisticsTop10(contextRoot, true, _dateTime)

    var getLogsAll_api = getLogsLogisticsAll(contextRoot, true, _logisticId, _keyword, _dateTime, logisticSort, offset, _rowsPerPage);
    $.when(getLogsAll_api).then(function (getLogsAll_result) {
      // let newTop10Driver = _.map(top10Driver_result.content, (el, index) => ({...el, sequence: index + 1}))
      // dispatch(setTopTenDriverList(newTop10Driver))
      var logsAll = _.map(getLogsAll_result.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: index + 1
        });
      });

      dispatch(setLogsLogisticsList(logsAll));
      dispatch(setLogisticTotal(getLogsAll_result.totalElements));
      Progress.done();
    }).catch(function (error) {
      console.log(error);
      Progress.done();
    });
  }; // useEffect(() => {
  //     if(!isMounted.current)
  //         return
  //     isChange.current = isDateTimeChange
  //     beforeDateTime.current = dateTime
  //     // fetchData()
  // }, [isDateTimeChange])


  useEffect(function () {
    if (!isMounted.current) {
      Progress.startSpin();
      dispatch(setDateTime(initDateTime));
      fetchData(true);
      isMounted.current = true;
    }

    return function () {
      dispatch(reset());
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "logisticDeliver-headBar"
  }, /*#__PURE__*/React.createElement(DateRange, {
    id: "logisticDeliver-datetime",
    enableTime: true,
    enableStartEndLabel: true,
    startLabel: t('lbl-start-time'),
    endLabel: t('lbl-end-time'),
    onChange: handleChangeDateTime // onClose={handleCloseDateRange}
    ,
    value: dateTime,
    limitRange: '30d' // t={(code, params) => {
    //     if (code === 'missing')
    //         return `Please input date`
    //     else {
    //         return `Invalid date format. Should be ${params.pattern}`
    //     }
    // }}

  }), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return fetchData();
    }
  }, gt('global.lbl-search'))), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(DeliverLog, null)));
};

LogisticDeliver.defaultProps = {
  id: 'g-logistic-deliver'
};
LogisticDeliver.PropTypes = {
  id: PropTypes.string
};
export default LogisticDeliver;